import { render, staticRenderFns } from "./pickupAudit.vue?vue&type=template&id=c452fbb4&scoped=true&"
import script from "./pickupAudit.vue?vue&type=script&lang=js&"
export * from "./pickupAudit.vue?vue&type=script&lang=js&"
import style0 from "./pickupAudit.vue?vue&type=style&index=0&id=c452fbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452fbb4",
  null
  
)

export default component.exports